<template>
	<div class="wrapper">
		<div v-if="!verifyShowImg">
			<div class="use" v-if="status===0 || status===2">
				<div class="head_tip">客服热线 0571-85199986(服务时间8:30-20:00)</div>
				<div class="head">
					<header>
						<div class="lt">
							<p>{{txt}}</p>
							<span>链接有效期至:{{expiredDate}}</span>
						</div>
						<img :src="imgUrl" alt="奈雪的茶">
						<span class="ico">电子券</span>
					</header>
				</div>
				<div class="body">
					<header>
						您已选择【{{txt}}】，本产品为虚拟产品，请务必核对账户正确，充值后不可撤销且无法退返，直充券码：充值结果请至品牌运营商后台核查，线下商户：请按照券码使用规则使用。
					</header>
					<div class="bd" v-if="status===2 || first">
						<h1>绑定手机号</h1>
						<div class="txt"><span>手机号</span><input type="number" placeholder="请输入手机号" v-model="accountNo"></div>
						<div class="form">
							<div class="code">
								<span>验证码</span>
								<input type="text" placeholder="请输入验证码" v-model="verifyCode">
							</div>
							<button v-if="verifyShow" @click="verifyCodeGet()">获取验证码</button>
							<em v-if="!verifyShow">{{verifyTime}}s</em>
						</div>
					</div>
					<div class="bd" v-if="status!==2 && !first">
						<h1>验证账号</h1>
						<div class="txt"><span>手机号</span><input type="tel" placeholder="请输入手机号" v-model="accountNo"></div>
					</div>
					<!-- <div class="ft">
						<p>温馨提示: 本产品为虚拟产品,兑换前请务必核对充值账户的正确性。为了保证您的利益，充值需通过短信验证，券码充值成功后无法退返，请至品牌运营商后台核查到账情况。客服热线:0571-85199986</p>
					</div> -->
				</div>
				<div class="foot">
					<button @click="submit" :disabled="disabled" v-if="status===2 || first">{{submitTxt}}</button>
					<button @click="verifyPhone" :disabled="disabled" v-if="status!==2 && !first">{{submitTxt}}</button>
				</div>
			</div>
			<div class="use" v-if="status===1 || status===3">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{txt}}</p>
							<span>有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd1">
					<div class="nodata">
						<img src="../assets/used.png" alt="电子券已使用">
						<p>电子券已使用</p>
					</div>
				</div>
			</div>
			<div class="use" v-if="status===4">
				<div class="head">
					<header class="used">
						<div class="lt">
							<p>{{txt}}</p>
							<span>有效期至:{{expiredDate}}</span>
						</div>
					</header>
				</div>
				<div class="bd1">
					<div class="nodata">
						<img src="../assets/outDate.png" alt="电子券已失效">
						<p>电子券已失效</p>
					</div>
				</div>
			</div>
			<div class="result" v-if="flag">
				<div class="dec">
					<img :src="srcDec" alt="成功">
					<p>{{dec}}</p>
				</div>
			</div>
			<div class="use_loading" v-if="loading">
				<div class="loading">
					<img src="../assets/loading.png" alt="加载中">
				</div>
			</div>
		</div>
		<div v-if="verifyShowImg">
			<div>
				<img class="use_loading" :src="showImgSrc">
			</div>
		</div>
		<div class="pop" v-if="takeVisible">
			<div class="win">
				<div class="box">
					<h4>电子券有效日期为：</h4>
					<label>生效时间：{{this.effectiveDate}} 00:00:00</label><br />
					<label>失效时间：{{this.expiredDate}} 23:59:59</label><br />
					<br />
					<label>温馨提示：本券码为特殊活动券，超过有效期券码会失效，失效券码请联系原购买渠道，若在有效期内无法使用请联系客服电话:0571-85199986</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				txt: '云之谷奈雪的茶电子券',
				key: this.$route.query.key,
				accountNo: '',
				mobile: '',
				flag: false,
				disabled: false,
				status: 0,
				submitTxt: '获取卡密',
				dec: '',
				srcDec: require('../assets/success.png'),
				seconds: 5,
				loading: true,
				expiredDate: '',
				amount: '',
				phoneNum: '',
				imgUrl: '',
				chargeType: 1,
				verifyShow: true,
				visible: true,
				verifyCode: '',
				verifyTime: 60,
				first: true,
				showType: 0,
				starbuckKey: '',
				productCategoryId: '',
				verifyShowImg: false,
				showImgSrc: '',
				// 是否生效，未生效弹出层挡住
				takeVisible: false,
				effectiveDate: ''
			}
		},
		mounted() {
			document.title = '云之谷奈雪的茶电子券';
			this.getTicketStatus(this.key);
		},
		methods: {
			verifyPhone() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						mobile: this.accountNo,
						isVerify: '1',
						ticketNo: this.key
					}
					this.disabled = true;
					this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// this.starbuckKey = res.data.outTicketPsw;
							this.minus('1');
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			verifyCodeGet() {
				if (this.visible) {
					this.visible = false;
					this.$http.POST('sms/send', {
						accountNumber: this.accountNo,
						type: 1
					}).then((res) => {
						this.flag = true;
						if (res.code === 0) {
							this.dec = '验证码发送成功';
							this.srcDec = require('../assets/success.png');
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.verifyShow = false;
							const timer = setInterval(() => {
								this.verifyTime--;
								if (this.verifyTime <= 0) {
									this.verifyShow = true;
									this.visible = true;
									clearInterval(timer);
									this.verifyTime = 60;
								}
							}, 1000);
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = '验证码发送失败';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			getTicketStatus(key) {
				const obj = {
					ticketNo: key
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					// console.log(res);
					this.loading = false;
					if (res.code === 0) {
						this.status = res.data.useStatus;
						this.txt = res.data.ticketName;
						document.title = this.txt;
						this.amount = res.data.amount + '元';
						this.expiredDate = res.data.expiredDate;
						this.imgUrl = res.data.productCategoryList ? res.data.productCategoryList[0].logoPath : '';
						this.productCategoryId = res.data.productCategoryList[0].productCategoryId
						if (res.data.accountNumber !== '') {
							this.first = false;
						}
						// 获取生效日期
						this.effectiveDate = res.data.effectiveDate;
						let d = res.data.effectiveDate
						if (d.length === 10) { // 加上时分秒
							d = d + " 00:00:00";
						}
						// 如果未生效，弹出提示
						if (new Date().getTime() < new Date(d).getTime()) {
							this.takeVisible = true
						}
					} else {
						if (res.code === 2000) {
							this.$router.push({
								path: '/404'
							})
						} else {
							alert(res.msg);
						}
					}
				});
			},
			minus(isVerify) {
				var _this = this;
				_this.submitTxt = '提交中...' + _this.seconds + 's';
				var time = window.setInterval(function() {
					if (_this.seconds === 0) {
						_this.seconds = 5;
						window.clearInterval(time);
						_this.getOrderInfo(isVerify);
					} else {
						_this.submitTxt = '提交中...' + _this.seconds + 's';
						_this.seconds -= 1
					}
				}, 1000)
			},
			submit() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else if (this.verifyCode === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入验证码！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						accountNumber: this.accountNo,
						ticketNo: this.key,
						code: this.verifyCode,
						productCategoryId: this.productCategoryId
					}
					this.disabled = true;
					this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							this.minus('1');
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}

			},
			getOrderInfo(isVerify) {
				const obj1 = {
					ticketNo: this.key,
					isVerify: isVerify,
					mobile: this.accountNo
				}
				this.$http.POST('productTicket/selectProductTicket', obj1).then(res => {
					this.flag = true;
					this.submitTxt = '获取卡密';
					if (res.code === 0) {
						this.dec = '充值成功';
						this.srcDec = require('../assets/success.png');
						// this.status = 1;
						this.showType = res.data.productCategoryList[0].showType;
						if (this.showType === 1) {
							this.$router.push({
								path: '/qrCode',
								query: {
									key: this.key,
									mobile: this.accountNo
								}
							})
						}
						if (this.showType === 3) {
							// this.$http.POST('productTicket/selectProductTicket',obj1).then(res=>{
							//     if(res.code === 0){

							//     }
							// })
							this.starbuckKey = res.data.outTicketPsw;
							window.location.href = this.starbuckKey;
							// window.location.href = this.starbuckKey;
						}
						if (this.showType === 2 || this.showType === 5) {
							this.$router.push({
								path: '/kamiCode',
								query: {
									key: this.key,
									mobile: this.accountNo
								}
							})
						}
						// 显示图片
						if (this.showType === 4) {
							this.verifyShowImg = true;
							this.showImgSrc = res.data.outTicketPsw;
							if (this.showImgSrc.indexOf("https") != -1) {
								this.showImgSrc = this.showImgSrc.replace("https", "http")
							}
						}
					} else {
						this.disabled = false;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		font-size: 16px;
		height: 100%;
		position: relative;

		.use {
			height: 100%;
			position: relative;

			.head_tip {
				background: #FEFCEC;
				padding: 10px;
				// line-height: 36px;
				font-size: 14px;
				color: #F76A24;
			}

			.head {
				height: 110px;
				background: #fff;
				padding: 10px 15px 15px 15px;
				box-sizing: border-box;

				header {
					height: 85px;
					background: url('../assets/recharge_bg.png') no-repeat;
					background-size: 345px 85px;
					position: relative;

					span.ico {
						position: absolute;
						bottom: 0;
						left: 0;
						border-bottom-left-radius: 4px;
						border-top-right-radius: 7px;
						font-size: 15px;
						color: #fff;
						padding: 0 4px;
						background: linear-gradient(to right, #FF8E00, #FF5500);
					}

					.lt {
						padding: 10px 0 0 15px;
						float: left;

						p {
							font-size: 17px;
							color: #333333;
							font-weight: bold;
						}

						span {
							font-size: 14px;
							color: #333333;
							padding-top: 2px;
						}
					}

					img {
						float: right;
						width: 68px;
						height: 68px;
						padding: 12.5px;
					}
				}

				header.used {
					background: url('../assets/used_bg.png') no-repeat;
					background-size: 345px 85px;
				}
			}

			.body {
				header {
					// height: 36px;
					background: #FEFCEC;
					padding: 10px;
					// line-height: 36px;
					font-size: 14px;
					color: #F76A24;
				}

				.bd {
					padding: 16px;

					h1 {
						font-size: 18px;
						font-weight: bold;
						color: #333333;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 232px;

							span {
								flex: 1;
							}

							input {
								width: 128px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 96px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #F76A24;
				}
			}

			.bd1 {
				display: flex;
				justify-content: center;
				align-items: center;

				.nodata {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding-top: 50px;

					img {
						width: 100px;
						height: 100px;
					}

					p {
						font-size: 17px;
						color: #555555;
						padding-top: 10px;
					}
				}
			}

			.foot {
				// position: absolute;
				// bottom: 0;
				padding: 70px 16px 16px 16px;
				display: flex;
				width: 100%;
				box-sizing: border-box;

				button {
					flex: 1;
					height: 60px;
					line-height: 60px;
					color: #fff;
					background: linear-gradient(to right, #F9AF2F, #F5881A);
					font-size: 17px;
					border-radius: 8px;
				}
			}
		}

		.result {
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;

			.dec {
				min-width: 120px;
				height: 120px;
				background: rgba(58, 58, 58, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				border-radius: 2px;
				padding: 0 10px;

				img {
					width: 36px;
					height: 36px;
					font-size: 14px;
				}

				p {
					font-size: 14px;
					color: #fff;
					padding-top: 8px;
				}
			}
		}

		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn 1s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}

		.pop {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;

			.win {
				width: 325px;
				height: 350px;

				p {
					text-align: right;
					padding-bottom: 10px;

					i {
						display: inline-block;
						width: 31px;
						height: 31px;
						background: url('../assets/close.png') no-repeat;
						background-size: 31px 31px;
					}
				}

				.box {
					width: 100%;
					height: 310px;
					background: #F3F3F3;
					border-radius: 7px;
					padding: 30px 15px;
					box-sizing: border-box;

					.submit {
						margin: 30px 25px 0 25px;
						width: 245px;
						height: 44px;
						border-radius: 22px;
						color: #fff;
						font-size: 18px;
						font-weight: bolder;
						background: linear-gradient(to right, #FF9A4F, #FF7509);
					}

					h1 {
						font-size: 18px;
						color: #333333;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}

					h4 {
						font-size: 18px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					label {
						font-size: 16px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}
				}
			}
		}
	}
</style>
